<div class="container">
  <div>•</div>
  <div>•</div>
  <div>•</div>
</div>
